import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsclose-icon',
	templateUrl:'./BSCloseIconPluginCompPage.html',
	styles: [],
	styleUrls:['./BSCloseIconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCloseIconPluginCompPage
{
	mdContent_800 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.close.BSCloseIcon;
\`\`\``;
	mdContent_801 = `\`\`\`java
BSCloseIcon()
\`\`\``;
	mdContent_802 = `\`\`\`java
BSCloseIcon&lt;?&gt; close = new BSCloseIcon&lt;&gt;();
close.addAttribute("aria-label", "Close");
\`\`\``;
}
